<svg
   xmlns="http://www.w3.org/2000/svg"
   preserveAspectRatio="xMaxYMin meet"
   width="272.476"
   height="394"
   viewBox="0 0 272.476 394"
>
   <g id="Group_83" data-name="Group 83" transform="translate(-1530.524 -637)">
      <g id="g66" transform="translate(1619.538 786.533)">
         <g id="g64" transform="translate(-89.015 -89.008)">
            <g id="g46" transform="translate(136.095)">
               <g id="g44">
                  <g id="g42">
                     <path
                        id="path40"
                        d="M0-89.008A136.086,136.086,0,0,1,129.425,5.024L0,47.077Z"
                        transform="translate(0 89.008)"
                        fill="#b1c4e2"
                     />
                  </g>
               </g>
            </g>
            <g id="g54" transform="translate(136.095 94.033)">
               <g id="g52">
                  <g id="g50">
                     <path
                        id="path48"
                        d="M129.425-27.505A136.086,136.086,0,0,1,79.989,124.643L0,14.548Z"
                        transform="translate(0 27.505)"
                        fill="#6b9ad2"
                     />
                  </g>
               </g>
            </g>
            <g id="g62">
               <g id="g60">
                  <g id="g58">
                     <path
                        id="path56"
                        d="M127.07,157.173A136.086,136.086,0,1,1,47.08-89.008V47.077Z"
                        transform="translate(89.015 89.008)"
                        fill="#597dad"
                     />
                  </g>
               </g>
            </g>
         </g>
      </g>
      <rect
         id="Rectangle_5"
         data-name="Rectangle 5"
         width="272"
         height="394"
         transform="translate(1531 637)"
         fill="none"
      />
   </g>
</svg>
